import React, { useEffect, useState, useRef } from 'react';
import { Helmet } from 'react-helmet';
import ChatComponent from './componentes/chatWindow/chat';
import { IoChatbubbles, IoChatbubbleEllipsesOutline } from "react-icons/io5";
import { useSearchParams } from 'react-router-dom';
import { initializeFeatureFlagsCache } from './functions/apiCalls/api';
import useViewportFix from './utils/useViewportFix';
import './App.css';

function App() {
  useViewportFix();
  const [chatActive, setChatActive] = useState(false);
  const [chatHeader, setChatHeader] = useState(true);
  const [searchParams] = useSearchParams();
  const [messages, setMessages] = useState([]);
  const [client_id, setClient_id] = useState('');
  const [operationalSystem, setOperationalSystem] = useState('');
  const [versionAPP, setVersionAPP] = useState('');
  const [origem, setOrigem] = useState(searchParams.get('origem') || 'chatbot');
  const [marca, setMarca] = useState(searchParams.get('marca') || '');
  const hoverTimeoutRef = useRef(null);


  useEffect(() => {
    if (window.self !== window.top) {
      document.body.classList.add('in-iframe');
    }
  }, []);

  useEffect(() => {
    const initializeApp = async () => {
      const active_chat = searchParams.get('active_chat');
      const client_id = searchParams.get('client_id');
      const operationalSystem = searchParams.get('operational_system')
      const versionAPP = searchParams.get('version_app')
      const origemParam = searchParams.get('origem') || 'chatbot';
      const marcaParam = searchParams.get('marca') || '';
      
      setOrigem(origemParam);
      setMarca(marcaParam);
      setVersionAPP(versionAPP);
      setClient_id(client_id);
      setOperationalSystem(operationalSystem);
      await initializeFeatureFlagsCache(client_id);
      if(active_chat === 'true'){
        toggleChat(true);
        setChatHeader(false);
      }
    };

    initializeApp();
  }, [searchParams]);

  const isSdkParam = searchParams.get('sdk');
  const disableHistoryParam = searchParams.get('disable_history') || searchParams.get('disableHistory');
  const isSdk = isSdkParam === 'true' || 
                isSdkParam === '1' || 
                disableHistoryParam === 'true' || 
                disableHistoryParam === '1';

  const resetChatSessionState = () => {
    setMessages([]);
    if (typeof window !== 'undefined') {
      window.currentConversationId = null;
      window.currentSessionId = null;
      window.currentRequestId = null;
      window.currentIdFluxoAgendamento = null;
      window.currentInsuranceSelected = null;
      window.currentCarterinhaManual = null;
      window.currentPerson = null;
      window.currentCustomer = null;
      window.currentClienteSexo = null;
      window.currentUnidadeSelecionada = null;
    }
  };

  const toggleChat = (forceActive) => {
    setChatActive(prev => {
      const next = typeof forceActive === 'boolean' ? forceActive : !prev;
      if (!next && isSdk) {
        resetChatSessionState();
      }
      return next;
    });
  };

  useEffect(() => {
    window.parent.postMessage({
      __chat_event: true,
      type: 'toggle',
      data: { active: chatActive }
    }, '*');
  }, [chatActive]);

  const handleHover = (hovering) => {
    if (hovering) {
      if (hoverTimeoutRef.current) {
        clearTimeout(hoverTimeoutRef.current);
        hoverTimeoutRef.current = null;
      }
      window.parent.postMessage({
        __chat_event: true,
        type: 'hover',
        data: { hovering: true }
      }, '*');
    } else {
      if (hoverTimeoutRef.current) {
        clearTimeout(hoverTimeoutRef.current);
      }
      hoverTimeoutRef.current = setTimeout(() => {
        window.parent.postMessage({
          __chat_event: true,
          type: 'hover',
          data: { hovering: false }
        }, '*');
        hoverTimeoutRef.current = null;
      }, 600); // 600ms delay to absorb transient mouseleave events during container resize transition

    }
  };

  return (
    <div className="App" data-origem={origem} data-marca={marca}>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no, viewport-fit=cover, interactive-widget=resizes-content" />
        {/* Configuração para permitir iframe apenas da mesma origem */}
        <meta http-equiv="X-Frame-Options" content="SAMEORIGIN" />
        {/* Política de segurança de conteúdo para permitir framing apenas da mesma origem */}
        <meta http-equiv="Content-Security-Policy" content="frame-ancestors 'none'" />
      </Helmet>
      {chatActive && <ChatComponent chatActive={chatActive} setChatActive={toggleChat} chatHeader={chatHeader} setMessages={setMessages} setClient_id={setClient_id} client_id={client_id} messages={messages} />}
      {!chatActive && (
        <div 
          className={`chat-button-wrapper ${origem === 'area_logada' ? 'area-logada' : ''}`}
          onMouseEnter={origem === 'area_logada' ? () => handleHover(true) : undefined}
          onMouseLeave={origem === 'area_logada' ? () => handleHover(false) : undefined}
        >
          {origem === 'area_logada' && (
            <div className="chat-tooltip">O que você precisa hoje?</div>
          )}
          <div className="chat-button" id="chat-button" onClick={toggleChat}>
            {origem === 'area_logada' ? <IoChatbubbleEllipsesOutline /> : <IoChatbubbles />}
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
